<template>
  <div
    :class="$style.modalContainer"
  >
    <StepHeader
      :class="$style.header"
      isVerifyStep
    />
    <VerifiedHead />
    <!-- TradeDesk pixel should not live here, refactor into it's own file
          or signupStoreConfig.js (this block was copied from SignUpConfirm.vue) -->
    <!-- TradeDesk Pixel -->
    <img
      alt=""
      :class="$style.pixel"
      height="1"
      src="https://insight.adsrvr.org/track/pxl/?adv=bgfmghe&ct=0:wndb6ja&fmt=3"
      style="border-style:none;"
      width="1"
    >
    <section :class="$style.content">
      <CelebrationImg :class="$style.illustration" />
      <HeadingLarge :class="$style.heading">
        Email Account Verified!
      </HeadingLarge>
      <ParagraphBody
        bodySize="large"
        :class="$style.text"
      >
        Thank you for verifying your email address. We are currently working to
        provision your account. A JumpCloud representative may reach out by phone or email.
        In the meantime, feel free to explore the resources below to learn more
        about what our product has to offer. Reach out to
        <Link
          href="mailto:sales@jumpcloud.com"
          target="_blank"
          text="sales@jumpcloud.com"
        />
        if you have any questions.
      </ParagraphBody>
      <div :class="$style.resourcesContainer">
        <HeadingExtraSmall :class="$style.resourcesHeader">
          While you are waiting, why not check out some additional resources?
        </HeadingExtraSmall>
        <div :class="$style.resourcesList">
          <div
            v-for="resource in resources"
            :key="resource.title"
            :class="$style.resource"
          >
            <div :class="$style.resourceTitleContainer">
              <CustomIcon :scale="1.5">
                <component
                  :is="resource.icon"
                />
              </CustomIcon>
              <Link
                :class="$style.resourceTitle"
                :href="resource.link"
                isMatchText
                target="_blank"
                :text="resource.title"
              />
            </div>
            <ParagraphBody
              bodySize="small"
              :class="$style.resourceDescription"
            >
              {{ resource.description }}
            </ParagraphBody>
          </div>
        </div>
      </div>
    </section>
    <Footer
      :class="$style.footer"
    />
  </div>
</template>

<script>
import {
  CustomIcon,
  HeadingExtraSmall,
  HeadingLarge,
  Link,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import BlogIcon from 'img/icons/icon-blog.svg';
import CelebrationImg from 'img/signup/celebration.svg';
import Footer from 'client/signup/components/Footer.vue';
import ResourcesIcon from 'img/icons/icon-resources.svg';
import StepHeader from 'client/signup/components/StepHeader.vue';
import VerifiedHead from 'client/signup/components/VerifiedHead.vue';
import VideoIcon from 'img/icons/icon-video.svg';

export default {
  name: 'Verified',

  components: {
    CelebrationImg,
    CustomIcon,
    Footer,
    HeadingExtraSmall,
    HeadingLarge,
    Link,
    ParagraphBody,
    StepHeader,
    VerifiedHead,
  },

  data: () => ({
    resources: [
      {
        title: 'Resource Hub',
        description: 'Find and engage with useful resources to inspire and guide your open directory journey.',
        icon: ResourcesIcon,
        link: 'https://jumpcloud.com/resources',
      },
      {
        title: 'Blog',
        description: 'Read about shifting trends in IT and security, industry news, best practices, and much more.',
        icon: BlogIcon,
        link: 'https://jumpcloud.com/blog',
      },
      {
        title: 'YouTube Channel',
        description: 'Watch videos to learn more about JumpCloud’s capabilities, how to use the platform, and more.',
        icon: VideoIcon,
        link: 'https://www.youtube.com/@Jumpcloud',
      },
    ],
  }),
};
</script>

<style module scoped>
@value (max-width-large) from '~css/breakpoints.css';

.modalContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  min-height: 42rem;
}

.pixel {
  position: absolute;
}

.content {
  padding: var(--jc-spacer-medium) var(--jc-spacer) 0;
  text-align: center;
}

.illustration {
  max-height: 20vh;
}

.heading {
  padding-top: var(--jc-spacer);
}

.text {
  padding: 0 8rem;
}

.resourcesContainer {
  border: var(--jc-border-width) solid var(--jc-border-color-medium);
  border-radius: 5px;
  margin-top: 3rem;
}

.resourcesHeader.resourcesHeader {
  background: var(--jc-background-light);
  margin-left: 25%;
  margin-top: -10px;
  width: 50%;
}

.resourcesList {
  display: grid;
  padding: var(--jc-spacer);
}

.resourceTitleContainer {
  align-items: center;
  display: flex;
}

.resourceTitle.resourceTitle {
  border-bottom: 0 !important;
  padding-left: var(--jc-spacer-small);
}

.resourceDescription {
  color: var(--jc-color-neutral-text-descriptive);
  padding-left: var(--jc-spacer-large);
  padding-top: var(--jc-spacer-small);
  text-align: left;
}

.footer {
  padding: var(--jc-spacer-medium) 0;
}

@media(max-width: max-width-large) {
  .resource {
    padding: var(--jc-spacer);
  }
}

@media (min-width: max-width-large) {
  .resourcesList {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .resource:not(:first-child) {
    padding-left: var(--jc-spacer-large);
  }

  .resource:not(:last-child) {
    border-right: var(--jc-border-width) solid var(--jc-border-color-medium);
    padding-right: var(--jc-spacer-large);
  }
}
</style>
